(function () {
  'use strict';

  function initFabricStory(el) {
    if (!el || el.dataset.fabricStoryInit) return;
    el.dataset.fabricStoryInit = 'true';

    var btn  = el.querySelector('.fabric-story__toggle');
    var body = el.querySelector('.fabric-story__body--clipped');
    var wrap = el.querySelector('.fabric-story__collapsible-wrap');

    if (!btn || !body || !wrap) return;

    var labelMore = btn.dataset.labelMore || 'Read more';
    var labelLess = btn.dataset.labelLess || 'Read less';

    btn.addEventListener('click', function () {
      var isOpen = body.classList.toggle('is-expanded');

      wrap.classList.toggle('is-expanded', isOpen);
      btn.setAttribute('aria-expanded', String(isOpen));

      var labelEl = btn.querySelector('.fabric-story__toggle-label');
      if (labelEl) {
        labelEl.textContent = isOpen ? labelLess : labelMore;
      }

      var iconEl = btn.querySelector('.fabric-story__toggle-icon');
      if (iconEl) {
        iconEl.textContent = isOpen ? '×' : '+';
      }
    });
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('.fabric-story--collapsible')
      .forEach(initFabricStory);
  }

  initAll(document);

  document.addEventListener('shopify:block:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();